export const mentorFormsList = [
  {
    id: 1,
    name: 'Mentor form',
    entityCreated: { at: 'Thu Aug 09 2018 08:46:00 GMT+0000 (UTC)' },
    entityUpdated: { at: 'Thu Sep 06 2018 08:46:00 GMT+0000 (UTC)' },
    isTemplate: true,
  },
];
